import { render, staticRenderFns } from "./DeleteFloors.vue?vue&type=template&id=d85f24d6&"
import script from "./DeleteFloors.vue?vue&type=script&lang=js&"
export * from "./DeleteFloors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports